var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.shouldShowOnboarding)?_c('OrderOnboarding'):_c('OrderDetails')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }